export const offsetCenter = (latlng, offsetx, offsety, mapRef, zoomOverride = 0) => {
  const map = mapRef;
  // latlng is the apparent centre-point
  // offsetx is the distance you want that point to move to the right, in pixels
  // offsety is the distance you want that point to move upwards, in pixels
  // offset can be negative
  // offsetx and offsety are both optional
  const zoomToUse = zoomOverride ? zoomOverride : map.getZoom();
  var scale = Math.pow(2, zoomToUse);

  var worldCoordinateCenter = map.getProjection().fromLatLngToPoint(latlng);
  var pixelOffset = new window.google.maps.Point(
    offsetx / scale || 0,
    offsety / scale || 0,
  );

  var worldCoordinateNewCenter = new window.google.maps.Point(
    worldCoordinateCenter.x - pixelOffset.x,
    worldCoordinateCenter.y + pixelOffset.y,
  );

  var newCenter = map
    .getProjection()
    .fromPointToLatLng(worldCoordinateNewCenter);

  return newCenter;
};
